import { InterviewGuideReminder } from '../core-data-model/InterviewGuideReminder.model';
import { OrderedSet } from '../core-data-model/OrderedSet';
import {
    TableColumnSettings,
    OnboardingState,
    OnboardingChecklist,
    OnboardingNextStepItemState,
    HireSpecificSettings,
    AiAssistantUserSettings
} from '../core-data-model/UserProfileSetting.model';

// Having a server setting does not make much sense for this one since
// it is an object totally under client control
export class CompanySpecificSettingServer {
    companyId: string;
    recentlySelectedFolderIds: OrderedSet<string>;
    recentlySelectedGroupIds: OrderedSet<string>;
    recentlySelectedJobs: OrderedSet<{ id: string; title: string }>;

    // Old
    recentlySelectedFolders?: OrderedSet<any>;
    recentlySelectedGroups?: OrderedSet<any>;
}

export interface IUserProfileSettingServer {
    version: string;
    currentCompany: string;
    companySpecificSettings: OrderedSet<CompanySpecificSettingServer>;
    showCognitiveData: boolean;
    completedCardAdministeredByMe: boolean;
    pendingCardAdministeredByMe: boolean;
    jobCardModifiedByMe: boolean;
    preferredPageSize: number;
    myOiLink: any;
    tableColumnSettings: TableColumnSettings;
    reminders: InterviewGuideReminder[];
    interviewReminderLastShown: string;
    hasAcknowledgedCogBestPractices: boolean;
    onboarding?: OnboardingState;
    firstLogin: string;
    onboardingChecklist?: OnboardingChecklist | OldOnboardingChecklist;
    onboardingNextSteps?: OnboardingNextStepItemState;
    freemiumFirstCandidateViewed: boolean;
    hireSettings: HireSpecificSettings;
    hasAcknowledgedWelcomeGuideCta: boolean;
    aiAssistantUserSettings?: AiAssistantUserSettings;
}

// typing for data from before 6/27/2019
export type OldOnboardingChecklist = {
    initialLogin: boolean;
    connectBehavioral: boolean;
    inviteEmployeesBA: boolean;
    addMoreUsers: boolean;
};
